import { render, staticRenderFns } from "./CmgOrderReward.vue?vue&type=template&id=61398e0e&scoped=true&lang=pug&"
import script from "./cmg-order-reward.ts?vue&type=script&lang=ts&"
export * from "./cmg-order-reward.ts?vue&type=script&lang=ts&"
import style0 from "./CmgOrderReward.vue?vue&type=style&index=0&id=61398e0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61398e0e",
  null
  
)

export default component.exports